import StyleOverrider from 'mrf/utils/StyleOverrider';
import tw, { styled } from 'twin.macro';

const DefaultStyledIcon = styled.span.attrs(
    ({ size, clickable, iconColor='normal', hoverColor='normal' }) => ({
        className: `flex w-${size} h-${size} fill-current text-${iconColor} hover:text-${hoverColor}`,
        as: clickable && 'button'
    })
)`
    ${({ disabled }) => disabled && tw`cursor-not-allowed hover:text-color-disabled text-color-disabled`}
`;

const DefaultStyledButtonIcon = styled(DefaultStyledIcon).attrs(
    ({ component, color }) => ({
        as: component ? 'div' : 'button',
        className: `hover:bg-${color}-light`
    })
)`
    ${tw`bg-card`}
    && {
        ${tw`grid items-center p-1 text-center transition-colors duration-300 ease-out rounded-full`}
    }

`;

const [StyledIcon, setStyledIconStyle] = StyleOverrider(DefaultStyledIcon);
const [StyledButtonIcon, setStyledButtonIconStyle] = StyleOverrider(DefaultStyledButtonIcon);
export { StyledIcon, DefaultStyledIcon, setStyledIconStyle, StyledButtonIcon, DefaultStyledButtonIcon, setStyledButtonIconStyle };
